// głowny plik, tu ładujemy dodatkowe moduły, skrypciki w common
define(['jquery', 'app/global', 'app/tools', 'app/common', 'shared/wid'], function ($, global, tools) {

  var $poi,
    $accordion,
    $flexslider,
    $promoRotator,
    $globalForms,
    $buyProcess,
    $contactForm,
    $expander,
    $stack,
    $layerLink,
    $layerLinkImages,
    $layerLinkHtmls,
    $layerLinkTxts,
    $layerRodoLinks,
    $crazySlider,
    $inlineGallery,
    $fundChart;

  if ('ontouchstart' in window && global.desktopSiteOnTablet) {
    global.cache.$html.removeClass('no-touch');
  }

  if (global.gs && global.ie && !global.cache.$html.is('.lt-ie10') && tools.canvasSupport) {
    // ie10-11
    require(['jquery.grayScale'], function () {
      $('.main img').grayscale();
    });
  }

  $poi = $('#poi');
  if ($poi.length) {
    require(['app/poi'], function (a) {
      a($poi);
    });
  }

  $accordion = $('.accordion').not('.static');
  if ($accordion.length) {
    require(['jquery.pkoAccordion'], function () {
      $accordion.pkoAccordion({
        unrollText: global.text.open,
        rolltext: global.text.close
      });
    });
  }

  $flexslider = $('.flexslider');
  if ($flexslider.length) {
    require(['jquery.flexslider'], function () {
      $flexslider.flexslider({
        animationSpeed: (global.ie8) ? 0 : 600,
        pauseOnHover: true,
        directionNav: false,
        start: function (slider) {
          if (window.PIE) {
            slider.find('.flex-control-paging, .flex-control-paging a').each(function () {
              window.PIE.attach(this);
            });
          }
        },
        after: function (slider) {
          if (window.PIE) {
            slider.find('.flex-control-paging a').each(function () {
              window.PIE.detach(this);
              window.PIE.attach(this);
            });
          }
        }
      });
    });
  }

  $promoRotator = $('#promo-rotator');
  if ($promoRotator.length) {
    require(['jquery.pkoPromoRotator'], function () {
      $promoRotator.pkoPromoRotator(); // 2DO
    });
  }

  // skrypty dla ccforms
  $globalForms = $('.ccform');
  if ($globalForms.length) {
    require(['jquery.pkoSendForm', 'jquery.maskedInput'], function () {

      $.mask.definitions['1'] = '[1-9]';
      $('.stationary_phone, .stationary_phone_mask').mask('19-199-99-99');
      $('.cell_phone, .cell_phone_mask, input.phone').mask('199-999-999');

      $globalForms.each(function () {

        var $this = $(this);

        if ($this.hasClass('non-ajax')) {
          return true;
        }

        tools.csrfToken($this);
        $this.pkoSendForm({
          doneCallback: function () {
            tools.ajaxOverflow.disable();
          },
          failCallback: function () {
            tools.ajaxOverflow.disable();
          },
          beforeSendCallback: function () {
            tools.ajaxOverflow.enable($this);
          }
        });

      });

    });

  }

  // skrypty dla jednego z ccforms
  $contactForm = $('.InteligoContactForm');
  if ($contactForm.length) {
    require(['shared/contact-form']);
  }

  $buyProcess = $('.buy-process');
  if ($buyProcess.length) {
    require(['jquery.pkoBuyProcess'], function () {
      $buyProcess.pkoBuyProcess();
    });
  }

  $stack = $('.stack');
  $expander = $('.stack-list .stack-list__expander');
  if ($stack.length || $expander.length) {
    require(['app/stack'], function (stack) {
      stack($stack, $expander);
    });
  }

  if (global.cache.$body.is('.pagemap')) {
    require(['app/site-map']);
  }

  if (global.cache.$body.is('.landing')) {
    require(['app/landing-page']);
  }

  // todo DELETE ME !!!!!
  $inlineGallery = $('.inlineGallery');

  if ($inlineGallery.length) {
    $inlineGallery
      .addClass('layer-link')
      .attr('href', global.staticDir + 'img/content/fund-transfer-example.png');
  }

  $layerLink = $('.layer-link, .js-rodo-form-popup');
  $layerLink.removeAttr('onclick').removeAttr('target');
  $layerLink = $layerLink.filter('[href]:not([href=""])');

  if ($layerLink.length) {

    $layerLinkImages = $layerLink.filter(function () {
      return /^(jpg|jpeg|png|gif)$/i.test(this.href.split('.').pop());
    });

    // html or htm and version: ?v=3, ?v5
    $layerLinkHtmls = $layerLink.filter(function () {
      return /^html?(\?v=?[0-9]+)?/i.test(this.href.split('.').pop());
    });
    $layerLinkTxts = $layerLink.filter(function () {
      return /^txt$/i.test(this.href.split('.').pop());
    });
    $layerRodoLinks = $layerLink.filter(function () {
      return this.className.indexOf('js-rodo-form-popup') > -1;
    });


    if (!global.desktopSiteOnTablet || $layerLinkImages.length || $layerRodoLinks.length) {

      require(['jquery.magnific-popup'], function () {

        if ($layerLinkImages.length) {
          $layerLinkImages.magnificPopup({
            type: 'image',
            image: {
              markup: '<div class="mfp-figure">' +
              '<div class="mfp-close"></div>' +
              '<div class="image-wrap"><div class="mfp-img"></div></div>' +
              '</div>',
              verticalFit: false
            },
            tLoading: 'Ładowanie zdjęcia...',
            tClose: 'Zamknij (Esc)',
            tError: '<a href="%url%">Zdjęcie</a> nie mogło zostać załadowane.',
            callbacks: {
              resize: function () {
                // własny verticalFit
                this.currItem.img.css('max-height', this.wH - 50);
              }
            }
          });
        }

        if ($layerRodoLinks.length) {
          $layerRodoLinks.magnificPopup({
            type: 'inline',
            midClick: true
          });
        }

        if (!global.desktopSiteOnTablet) {
          if ($layerLinkHtmls.length) {
            $layerLinkHtmls.magnificPopup({
              type: 'iframe',
              tLoading: 'Ładowanie pliku html...',
              tClose: 'Zamknij (Esc)',
              tError: '<a href="%url%">Plik html</a> nie mógł zostać załadowany.',
              callbacks: {
                beforeAppend: function () {
                  var iframe = this.content.find('iframe'),
                    iframeLink = iframe.attr('src');
                  if (iframeLink && tools.isLocalLink(iframeLink)) {
                    iframe.on('load', function () {
                      iframe.contents().find('.pop-up-close').on('click', function (e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                      });
                    });
                  }
                }
              }
            });
          }

          if ($layerLinkTxts.length) {
            $layerLinkTxts.magnificPopup({
              type: 'iframe',
              tLoading: 'Ładowanie pliku tekstowego...',
              tClose: 'Zamknij (Esc)',
              tError: '<a href="%url%">Plik tekstowy</a> nie mógł zostać załadowany.'
            });
          }
        }

      });

    }

    if (global.desktopSiteOnTablet && ($layerLinkHtmls.length || $layerLinkTxts.length)) {

      $layerLinkHtmls.add($layerLinkTxts).on('click', function (e) {
        var template = tools.substitute(tools.getTemplate('tablet-pop-up'), {
            iframe: '<iframe id="iframe-popup-tablet" src="' + this.href + '"></iframe>'
          }),
          iframe,
          iframeLink;
        global.cache.$body.addClass('tablet-pop-up-on')
          .append(template);
        $('.tablet-pop-up__header').on('click', function () {
          $('#tablet-pop-up').remove();
          global.cache.$body.removeClass('tablet-pop-up-on');
        });
        iframe = $('#iframe-popup-tablet');
        if (iframe.length) {
          iframeLink = iframe.attr('src');
          if (iframeLink && tools.isLocalLink(iframeLink)) {
            iframe.on('load', function () {
              iframe.contents().find('.pop-up-close').on('click', function (e) {
                e.preventDefault();
                $('#tablet-pop-up').remove();
                global.cache.$body.removeClass('tablet-pop-up-on');
              });
            });
          }
        }
        window.scrollTo(0, 0);
        e.preventDefault();
        return false;
      });

    }

  }

  $crazySlider = $('.crazy-slider');
  if ($crazySlider.length) {
    require(['jquery.crazySlider'], function () {
      $crazySlider.crazySlider();
    });
  }

  $fundChart = $('.fundChart');
  if ($fundChart.length) {
    require(['svg-chart'], function (SvgChart) {
      var paper = $('#paper'),
        startArr = paper.data('start').split(' '),
        monthIndexStart = $.inArray(startArr[1], ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']) + 1,

        paperData = {
          id: paper.data('id'),
          start: startArr[2] + '-' + (monthIndexStart > 9 ? '' : '0') + (monthIndexStart) + '-' + (parseInt(startArr[0]) < 10 ? '0' : '') + startArr[0],
          end: (new Date()).toJSON().slice(0, 10)
        };

      $.ajax({
        type: 'POST',
        url: '/_ajax/rest/v1/tfi/found/' + paperData.id + '/values/?format=json&date__lte=' + paperData.end + '&date__gte=' + paperData.start,
        dataType: 'json',
        data: $(this).serialize(),
        success: function (response) {
          SvgChart.render(paper, response, true);
          $('#svg-data').fadeOut('slow', function () {
            $('#paper').fadeIn('slow');
          });
        },
        error: function (r, s, e) {
          //DO ZROBIENIA
        }
      })

      function resizeWrapper() {
        var container = $('#chartContainer'),
          svgElement = $('#paper'),
          width = container.width() - 5,
          height = container.height(),
          ratio = 610 / 290;

        svgElement.width(width);
        svgElement.height(width / ratio);
      }

      $(window).resize(resizeWrapper)

      $(document).ready(function () {
        $('.documents_alias_import').find('a').attr('target', '_blank');

      });
    });
  }

  // $subfundAccount = $('.inlineGallery');
  // if( $subfundAccount.length ) {

  //     $subfundAccount.click( function(e) {
  //         e.preventDefault();
  //         $('.popup-with-image').fadeIn();
  //         $('.poi-pop-up__head-close').click( function(e) {
  //             e.preventDefault();
  //             $('.popup-with-image').fadeOut();
  //         });
  //     });
  // }

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/main.js